import React, { Component, Fragment } from 'react';
import BillBoard from './billBoard';
import './bcac.css';
import {numberOnly} from '../../../server/util';
class AuthorizePersons extends Component {
    constructor(){
        super()
        this.state={
            errors:{}
        }
    }
    validateAuthorizePersons=()=>{
        let valid=true;
        const {students}=this.props;
        const _errors={};
        Object.keys(students||{}).filter(s=>{
            return students[s].isSelected
        }).map((sid,i)=>{
            _errors[sid]=[];
            (students[sid].authorisedPersons||[]).map(auth=>{
                if(((auth.firstName||'').trim()).length<=0 ||
                ((auth.phoneNo||'').trim()).length<=0 ||
                ((auth.relation||'').trim()).length<=0 ){
                    if(auth.isActive){
                        _errors[sid].push('Please fill all details');
                        valid=false;
                    }else{
                        _errors[sid].push('');
                    }                    
                }else{
                    _errors[sid].push('');
                }
            });
        })
        this.setState({errors:_errors});
        return valid;
    }

    render() {
        const {students}=this.props;
        const {errors}=this.state;
        return ( 
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="border_thumb">
                                    <div className="row">
                                        <div className="col-md-12">                                        
                                            <div className="caption bcacBox ">
                                                <div className="leftBox">
                                                    <h5>Add persons authorized to pickup</h5>
                                                    {
                                                        Object.keys(students||{}).map((sid,i)=>{
                                                            const fullName=`${students[sid].lastName}, ${students[sid].firstName}`;
                                                            if(students[sid].isSelected){
                                                           return (<Fragment>
                                                                <div className="row form-group">
                                                                    <div className="col-md-11">
                                                                        <h5>{fullName}</h5>
                                                                    </div>
                                                                    <div className="col-md-1 text-right">
                                                                    <button className="btn-xs btn-success" onClick={()=>{
                                                                            this.props.addDeleteAuthorizedPerson(sid,undefined,'Add');
                                                                        }}><i className="fa fa-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    (students[sid].authorisedPersons||[]).map((person,j)=>{
                                                                        if(person.isActive){
                                                                        return (<Fragment><div className="row form-group">
                                                                    <div className="col-md-3">
                                                                        <input type="text" name="firstName" value={person.firstName} placeholder="First Name" 
                                                                        className="form-control" maxlength="20"  onChange={(e)=>{
                                                                            this.props.onChangeAuthorizedPersonValues(sid,j,e);
                                                                            this.validateAuthorizePersons();
                                                                        }} />
                                                                    </div>
                                                                    <div className="col-md-2">
                                                                        <input type="text" name="lastName" value={person.lastName} placeholder="Last Name" 
                                                                        className="form-control" maxlength="20"  onChange={(e)=>{
                                                                            this.props.onChangeAuthorizedPersonValues(sid,j,e);
                                                                            this.validateAuthorizePersons();
                                                                        }} />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <input type="text" name="phoneNo" maxlength="10"  value={person.phoneNo} placeholder="Phone No" 
                                                                        className="form-control" onKeyPress={numberOnly}  onChange={(e)=>{
                                                                            this.props.onChangeAuthorizedPersonValues(sid,j,e);
                                                                            this.validateAuthorizePersons();
                                                                        }}/>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <select className="form-control"  value={person.relation} name="relation" placeholder="Relation" 
                                                                        onChange={(e)=>{
                                                                            this.props.onChangeAuthorizedPersonValues(sid,j,e);
                                                                            this.validateAuthorizePersons();
                                                                        }}>
                                                                            <option value=""></option>
                                                                            <option value="Parent">Parent</option>
                                                                            <option value="Sibling">Sibling</option>
                                                                            <option value="Friend">Friend</option>
                                                                            <option value="Other">Other</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-md-1">                                                                        
                                                                        <button className="btn-xs btn-danger" onClick={()=>{
                                                                            this.props.addDeleteAuthorizedPerson(sid,j,'Del');
                                                                        }}><i className="fa fa-trash"></i></button>
                                                                    </div>
                                                                </div>
                                                                <div className="row form-group">
                                                                    <div className="col-md-12">
                                                                        <span className="color-3">{(errors[sid]||[])[j]||''}</span>
                                                                    </div>
                                                                </div>
                                                                </Fragment>);
                                                                }else{
                                                                    return null;
                                                                }
                                                                    })
                                                                }                                                                
                                                            </Fragment>);
                                                            }else{
                                                                return null
                                                            }
                                                        })
                                                    }
                                                </div>
                                                <div className="rightBox">
                                                    <BillBoard {...this.props} />
                                                </div>                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                <div className="col-xs-12 text-center">
                    <button className="btn btn-prev btn-xs bg-color-2 pull-left" onClick={(e)=>{
                        this.props.jumpToStep(0)
                    }}>Previous
                    </button>
                    {
                        Object.values(this.props.students||{}).some((s,i)=>{
                            return (s.isSelected && !s.isRegistered)
                        })?null:
                        <button className="btn btn-prev btn-xs bg-color-1" onClick={(e)=>{
                            const {students}=this.props;
                            let authorisedPersons=[];
                            Object.keys(students||{}).map((sid,i)=>{
                                if(students[sid].isSelected){
                                    (students[sid].authorisedPersons||[]).map((person,j)=>{
                                        if(((person.firstName||'').trim()).length>0){
                                            authorisedPersons.push({
                                                authorizedId:person.authorizedId,
                                                firstName:person.firstName,
                                                lastName:person.lastName,
                                                phoneNo:person.phoneNo,
                                                relation:person.relation,
                                                stdRecId:sid,
                                                isActive:person.isActive
                                            });
                                        }
                                    })
                                }
                            });
                            if(!this.validateAuthorizePersons()){
                                return false;
                            }else{
                                this.props.saveAuthorizedPersons(authorisedPersons);
                            }                            
                        }}>Save authorized pickup persons
                        </button>
                    }
                    
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                         if(!this.validateAuthorizePersons()){
                            return false;
                        }else{
                            this.props.jumpToStep(2);
                        }
                    }}>Next
                    </button>
                </div>
            </div>
            </Fragment>
         );
    }
}
 
export default AuthorizePersons;


// WEBPACK FOOTER //
// ./src/components/Parent/bcac/authorizePersons.jsx